function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("symbol", {
  id: "raindrop"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0062bf",
  d: "M2.5,13A2.5,2.5,0,0,1,.21,9.51l3.55-8a2.5,2.5,0,0,1,4.57,2l-3.55,8A2.5,2.5,0,0,1,2.5,13Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("symbol", {
  id: "lightning"
}, /*#__PURE__*/React.createElement("polygon", {
  fill: "#ffdd15",
  points: "19.6 23.42 12.74 20.39 15.55 5 5 24.49 12.08 27.51 7.49 45 19.6 23.42"
}));

var _ref4 = /*#__PURE__*/React.createElement("symbol", {
  id: "cloud"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55.7,5A23.94,23.94,0,0,0,34.37,18.05a9.9,9.9,0,0,0-12.78,5.56,15,15,0,0,0-1.71-.1A14.81,14.81,0,0,0,9.2,28,14.63,14.63,0,0,0,5,38.17v.21A14.83,14.83,0,0,0,19.88,53.06H75.59a14.3,14.3,0,0,0,3.67-28.14A23.93,23.93,0,0,0,55.7,5Z"
}), /*#__PURE__*/React.createElement("image", {
  x: 5,
  y: 14,
  width: 85,
  height: 43,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAAAkCAMAAAAkYj0PAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURSgoKExpcaCgoFBQUG5ublBQUISEhI1fsT0AAAAHdFJOUxsACBsPFRpGXuFgAAABWElEQVRIx7XV25bDIAgF0BMu/v8nF/E+iWlqHNKVN3cpIMXxL4GFM3SQfTazkUyxk63oLYwlVSy2silXkS/wUrZS2a3ZCn1zsdSw7UUYijuHsTa1IvfwWrbSXLkc4N9r27JViwmM1UtWXA3hohQ41m6vl8FQZi7wu2z7KXPW4uRiZS+2AmdXN7DdQEQWQHYHlt6z0dXBBa2xeeVktiZc1jDoF5eGkI4d4MjKc7cNbZ3bqjocLLx5oPDYTaIftcfvAvcs2GFxVsJTOP1wO1jGdUSLaz/DWA1Tl45+Tkqul2ArcPzayGq8JafOUffP3TUp6JQs+Rptc6vtmtBkUw+dv0NzWG0PYf8O7Ym09+ITXyXOPZqEX95aFe3PKxRsL2XV3HR+ZALirPSF0ceHp6F51WBv1A22VaW2GHWzWvat8LOAPf4CrjrA+neNK7+PQBf/DmmLrId09/QDWyESBsibwBUAAAAASUVORK5CYII="
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "lightning_37_51_1_1_4"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  fill: "white"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#lightning",
  fill: "black",
  stroke: "black",
  strokeLinejoin: "round",
  strokeWidth: 8,
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  transform: "translate(37,51) scale(1,1)"
})));

var _ref6 = /*#__PURE__*/React.createElement("symbol", {
  id: "s11"
}, /*#__PURE__*/React.createElement("g", {
  mask: "url(#lightning_37_51_1_1_4)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cloud",
  fill: "#999999",
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  transform: "translate(3,18) scale(1,1)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#lightning",
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  transform: "translate(37,51) scale(1,1)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#raindrop",
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  transform: "translate(18,78) scale(1,1)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#raindrop",
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  transform: "translate(29,87) scale(1,1)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#raindrop",
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  transform: "translate(55,79) scale(1,1)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#raindrop",
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  transform: "translate(68,78) scale(1,1)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#raindrop",
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  transform: "translate(82,87) scale(1,1)"
}));

var _ref7 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s11",
  x: 0,
  y: 0,
  width: 100,
  height: 100
});

function SvgHeavyrainandthunder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavyrainandthunder);
export default __webpack_public_path__ + "static/media/heavyrainandthunder.b1bb9b2f.svg";
export { ForwardRef as ReactComponent };